import React from 'react';
import PropTypes from 'prop-types';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import Image from 'marketing-website/components/modules/Image';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';
import assets from 'marketing-website/configs/pages/features/collaboration/assets';

export default function DirectoryBlock({ color }) {
  return (
    <PageWrap size="l">
      <Spacing size="xl" type="padding" position="topBottom">
        <Grid columns={12} alignItems="center">
          <GridItem columnSpan={12} columnSpanM={7}>
            <MediaMultipleImages
              fallbackImageAlt="See what everyone is working on"
              fallbackImageSrc={assets.directoryFallback.src}
              fallbackImageMaxWidth={550}
            >
              <Shape
                type="rectangle"
                color="lightOrange"
                width={400}
                height={345}
              />
              <ParallaxWrapper speed={1}>
                <Pattern
                  color={color}
                  right="auto"
                  left="24%"
                  top="auto"
                  bottom="24%"
                  type="shortRectangle"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={1.7}>
                <Image
                  {...assets.directory}
                  borderRadius="m"
                  left="30%"
                  maxWidth={400}
                  position="absolute"
                  top="28%"
                />
                <ParallaxWrapper>
                  <Image
                    {...assets.personRow}
                    borderRadius="m"
                    left="27%"
                    maxWidth={452}
                    position="absolute"
                    top="42%"
                  />
                </ParallaxWrapper>
              </ParallaxWrapper>
            </MediaMultipleImages>
          </GridItem>
          <GridItem columnSpan={12} columnSpanM={5}>
            <HeadingBlock
              justifyContent="center"
              justifyM="start"
              maxWidth={440}
              title="Create and iterate, together"
              copy={
                <span>
                  It's our mission to democratise design collaboration which
                  will improve the creative process - making design more
                  inclusive, collaborative and innovative.
                  <br />
                  <br />
                  Instant access to all company projects for your directory
                  members, means full visibility for your colleagues and helps
                  you get to your best idea fast.
                </span>
              }
            />
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}

DirectoryBlock.propTypes = {
  color: PropTypes.string,
};

DirectoryBlock.defaultProps = {
  color: null,
};



// WEBPACK FOOTER //
// ./src/pages/features/collaboration/DirectoryBlock.js